import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';

const VARIANTS = ['regular', 'secondary', 'secondaryBold', 'tertiary', 'tertiaryBold'];

const styles = ({ links }) => ({
  root: ({ variant }) => {
    const commonStyles = {
      textDecoration: 'none'
    };
    switch (variant) {
      case 'secondaryBold':
        return {
          ...links.link,
          ...links.linkSecondaryBold,
          ...commonStyles
        };
      case 'tertiary':
        return {
          ...links.link,
          ...links.linkTertiary,
          ...commonStyles
        };
      case 'tertiaryBold':
        return {
          ...links.link,
          ...links.linkTertiaryBold,
          ...commonStyles
        };
      case 'regular':
      case 'secondary':
      default:
        return {
          ...links.link,
          ...commonStyles
        };
    }
  }
});

const Body = ({
  classes,
  className,
  children,
  href,
  variant: _variant,
  theme: _theme,
  ...props
}) => {
  const classNames = `${classes.root} ${className}`;
  return (
    <a href={href} className={classNames} {...props}>
      {children}
    </a>
  );
};

Body.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  theme: PropTypes.shape({}).isRequired,
  href: PropTypes.string,
  variant: PropTypes.oneOf(VARIANTS),
  className: PropTypes.string
};

Body.defaultProps = {
  variant: 'p',
  href: '#',
  className: ''
};

export default withStyles(styles)(Body);
